import KatalMetricsSellerCentral from '@katal/metrics-sellercentral';
import * as KatalMetrics from '@katal/metrics';
import { removeQueryString } from './utils';

const SERVICE_NAME = 'KatalMetrics';

const ERRORS_TO_IGNORE = [
  'KatalMetricsSellerCentral could not auto-detect domain for metrics',
  'KatalMetricsSellerCentral could not auto-detect realm for metrics',
  'KatalMetricsSellerCentral could not detect http_request_id',
];

/**
 * @param sushiDriver An optional driver for testing.
 */
export function createMetricsPublisher(sushiDriver?: any) {
  const metricsErrorHandler = err => {
    //We know some errors will be thrown due to auto detection for seller central.
    //We do not care about these errors on internal apps and should not be logging faults about them
    if (ERRORS_TO_IGNORE.indexOf(err.message) >= 0) {
      return;
    }
    console.warn(err);
  };

  let pageType = '';
  let subPageType = '';
  if (window.uept && window.uept.pageType) {
    pageType = window.uept.pageType;
    subPageType = window.uept.subPageType || '';
  }

  const contextBuilder = KatalMetricsSellerCentral.makeContextBuilder(
    SERVICE_NAME,
    metricsErrorHandler
  );

  // strip off the query string
  const url = removeQueryString(window.location.href);

  contextBuilder.addRelatedMetrics(
    ...[
      new KatalMetrics.Metric.String('url', url),
      new KatalMetrics.Metric.String('pageType', pageType),
      new KatalMetrics.Metric.String('subPageType', subPageType),
      // eslint-disable-next-line no-undef
      new KatalMetrics.Metric.String('katalBuildTime', KATAL_BUILD_TIME),
    ].map(s => {
      s.truncate = true;
      return s;
    })
  );

  if (!sushiDriver) {
    sushiDriver = KatalMetricsSellerCentral.makeDriverConfigBuilder(
      metricsErrorHandler
    ).build();
  }

  const publisher = new KatalMetrics.Publisher(
    sushiDriver,
    metricsErrorHandler,
    contextBuilder.build()
  );

  return {
    publisher: publisher.newChildActionPublisherForMethod('Load'),
    sushiDriver,
  };
}
